module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "c01"
    }
  }), _vm._v("Chapter One")]), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("The Ritual of the Mark of the Beast")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("leister Crowley wrote a great number of magical rituals during his long and prolific career, but arguably his finest ritual is Liber V vel Reguli, which was originally published in Crowley's masterpiece "), _c('i', [_vm._v("Magick in Theory and Practice")]), _vm._v(" in 1929. This rite, also known as the Mark of the Beast ritual, is a version of one of the most fundamental rituals in the Hermetic magical tradition, the Pentagram Ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Pentagram rituals belong to a class of ritual generally known as “Banishing” rituals, although that's rather a misleading term, since they don't really just “banish” things. They are designed to set up a neutral ritual space that a magician can work in, and to invoke energy into the magician in order to power the Will. A pentagram ritual is an entirely self-contained magical operation, and the regular practice of doing one of these pentagram rituals is highly recommended to beginning magicians.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Pentagram rituals were first popularised in the late 19"), _c('sup', [_vm._v("th")]), _vm._v(" century by the Golden Dawn magical order, where Aleister Crowley received much of his early training. The Golden Dawn and its followers make much of the theory that all magical work should be opened and closed by a pentagram ritual being performed. This is far from being the universal law that some people might claim, and although it can certainly be beneficial in some cases, is rarely necessary. It also tends to reduce the pentagram ritual from the position of being a perfectly fine invocation in itself to being something that's little more than a prelude to other magical work, which is a terrible shame.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Aleister Crowley was a huge fan of the pentagram ritual, and taught the Golden Dawn version of it to all of his early students. However as time went on Crowley rightly saw that the G.D.'s pentagram ritual, despite its popularity, had some serious technical faults, and for many years attempted to amend and improve it. His first attempt was a ritual called the Star Ruby, published in the "), _c('i', [_vm._v("Book of Lies")]), _vm._v(" around 1912, and later even more amended.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Even that didn't seem to be enough for Crowley though, and in the 1920's he began work on the Mark of the Beast ritual, an even more radical revision of the Pentagram ritual. The O.T.O. Archives contain an early typescript of the ritual made by Crowley in about 1926, complete with several notes by him and one of his young students at the time, Gerald Yorke. The version "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("presented in the typescript is obviously a work in progress, and contains sections later excised or radically changed in the final published version. In particular, in contrast to the final solo version of "), _c('i', [_vm._v("Liber Reguli,")]), _vm._v(" this early draft was intended to be a ritual for group working.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We know that Crowley had been using some kind of Pentagram ritual as part of O.T.O. group workings in 1921, when he wrote to the head of the American O.T.O., Charles Stansfeld Jones:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("“We are having great success every night with rituals, the order being Pentagram, Creed, Collects, then anything special as occasion dictates, Benediction and O.T.O. applause. The effect has been magnificent.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Crowley to Jones, January 25, 1921")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The Creed, Collects, and Benediction were taken from the text of "), _c('i', [_vm._v("Liber XV,")]), _vm._v(" The Gnostic Mass, which was designed from the outset as a group rite, however Pentagram rituals up until this point were primarily designed for solo practitioners. I think it quite likely then that the Mark of the Beast ritual may have been designed by Crowley around this period as an attempt to remedy this and create a more group-oriented Pentagram ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The group sections in Crowley's early recension of the Mark of the Beast ritual are fairly minimal, being confined to a chorus adding Thelemic affirmations to the beginning/ending section of the rite (the “Qabalistic Cross” sections). The bulk of the rite is basically a fairly standard pentagram ritual performed by one person. As such it's not really an ideal group working, which is probably why Crowley dropped the group parts when he published it in 1929. However I do think that with the group sections added back in, it could be very useful as a ritual to open or close a general Lodge meeting, and a good way to get people involved in the performance of this excellent rite.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("If your group is holding regular meetings or classes that don't have a major ritual component, one good exercise might be to have one member of the group (called the Magician in the ritual) perform this at the start or end of the evening, rotating this principal role at every meeting so that each member of the group gets to do the “starring role” at least once. Be careful not to fall into the trap of having the same person or couple of people do the principal role each time. If someone says “You know it better than me, so you should do it every time” then that's a message that they need to be taught how to do it better! The last thing any group needs is a couple of experienced people doing everything and not leaving room for new members to learn and flourish. So do please resist that temptation at all costs. Remember that one of the foundation stones of Thelema is that “every man and every woman is a star”, so make sure everyone has a chance to shine.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("The original typescript of the Mark of the Beast ritual has several points with question marks after them, and in a couple of places has several variations of the symbols marked out; clearly showing that Crowley didn't consider it complete, and was still trying to work out how it should all fit together. I spent some considerable time trying to reconstruct a working version of the rite from the original Crowley typescript notes, but eventually realised that if Crowley couldn't do it then I probably couldn't either.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In the end I decided to just use the published version from "), _c('i', [_vm._v("Magick in Theory and Practice,")]), _vm._v(" since clearly that was what Crowley considered the final revision; but with the addition of the original group parts from the early version. As soon as I added those back in and made a couple of minor tweaks, suddenly the ritual began to make sense as a viable group rite.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("This synthetic version also has the advantage that if you already know the standard solo version of the Mark of the Beast ritual, it's quite easy to perform the role of the Magician in a group setting without having to shift gears radically; and conversely, being part of a group performance of it helps you learn it as a ritual for your own solo workings.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Note that in this ritual the pentagrams are drawn “averse”, or upside-down to what is general usage in most Pentagram rituals. Contrary to popular belief, this does not imply that they are “evil” or “negative” in any way - really there's no such thing as the “correct” way to draw a pentagram, it's purely a convention. The pentagram is a star, and stars in the sky have no up or down, right way or averse way, they just are. I suspect that Crowley drew them this way because conventionally the single point upright pentagram symbolically refers to the divine spirit conquering matter, whereas the two points upward version refers to the divine descending into matter. Since the Mark of the Beast ritual is essentially about bringing divine energy down to the earth (as is invocation generally), then using the pentagrams in this form makes logical sense.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("An interesting feature of this ritual is that it uses the so-called Invoking Pentagrams, rather than the Banishing Pentagrams used in most other Pentagram rituals. Frankly I don't consider it particularly important either way since all Pentagram rituals are essentially invocations of divine energy regardless of which pentagram you use or what way up you draw it. For more information on the pentagrams used in the Golden Dawn tradition see "), _c('span', {
    attrs: {
      "href": "#/24_appendixi#app-i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I")]), _vm._v(" of this book.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p4-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig1"
    }
  }), _c('b', [_vm._v("The Oath of the Enchantment")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p4-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig2"
    }
  }), _c('b', [_vm._v("The Chakras")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("The Ritual of the Mark of the Beast: Group Version")]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "75%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Participants:")])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Minimum 2. The rite works well with a small group.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Time required:")])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("15 minutes.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Setup:")])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Minimal.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Words:")])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Relatively simple.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Equipment:")])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "blockquotea"
  }, [_c('ul', {
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_c('li', [_vm._v("Wand")]), _vm._v(" "), _c('li', [_vm._v("Robe")])])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "c01-02"
    }
  }), _vm._v("The FIRST GESTURE")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("The Oath of the Enchantment, which is called The Elevenfold Seal.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('i', [_c('b', [_vm._v("The Animadversion towards the Aeon.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. Let the Magician, robed and armed as he may deem to be fit, turn his face towards Boleskine, that is the House of The Beast 666.")]), _vm._v(" "), _c('p', {
    staticClass: "textb"
  }, [_c('i', [_vm._v("{Note 1: Boleskine House is on Loch Ness, 17 miles from Inverness, Latitude 57.14 N. Longitude 4.28 W.}")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[The people should normally stand outside the circle, facing the Magician, unless you have a really big temple or are working outdoors, in which case you may have room for the people to stand inside the circle. In practice the Magician needs plenty of room to move around freely during the rite, so having the people within the circle rarely works well.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteindent"
  }, [_c('i', [_vm._v("Thelemic rituals are normally oriented towards Boleskine, the house where Aleister Crowley lived when he received the")]), _vm._v(" Book of the Law; "), _c('i', [_vm._v("in a similar way to how Moslem rituals are oriented towards Mecca - it provides a common point of focus for everyone.]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2. Let all strike the battery 1-3-3-3-1.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[The best way to do this in a group setting is to have the Magician and all members of the group clap together, in a battery of one clap, three claps, three claps, three claps, one clap. Crowley's original notes have just the Magician doing the battery, but in practice I've found that having everyone do it together is greatly preferable.]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("3. Let the Magician put the Thumb of his right hand between its index and medius, and make the gestures hereafter following.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p6-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig3"
    }
  }), _c('b', [_vm._v("The Averse Invoking Pentagrams")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p6-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig4"
    }
  }), _c('b', [_vm._v("The Unicursal Hexagram")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p6-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig5"
    }
  }), _c('b', [_vm._v("The Mark of the Beast")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("The Vertical Component of the Enchantment.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. Let him describe a circle about his head, crying "), _c('b', [_vm._v("NUIT!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[Note that generally when Crowley writes a word or phrase In all capital letters he means it to be intoned in a sonorous manner, rather than just spoken normally.]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2. Let him draw the Thumb vertically downward and touch the Muladhara Cakkra, crying, "), _c('b', [_vm._v("HADIT!")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("3. Let him, retracing the line, touch the centre of his breast and cry "), _c('b', [_vm._v("RA-HOOR-KHUIT!")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("All: Do what thou wilt shall be the whole of the Law.")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("The Horizontal Components of the Enchantment.")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_vm._v("Let him touch the Centre of his Forehead, his mouth, and his larynx, crying "), _c('b', [_vm._v("AIWAZ!")])]), _vm._v(" "), _c('li', [_vm._v("Let him draw his thumb from right to left across his face at the level of the nostrils.")]), _vm._v(" "), _c('li', [_vm._v("Let him touch the centre of his breast, and his solar plexus, crying, "), _c('b', [_vm._v("THERION!")])]), _vm._v(" "), _c('li', [_vm._v("Let him draw his thumb from left to right across his breast, at the level of the sternum.")]), _vm._v(" "), _c('li', [_vm._v("Let him touch the Svadistthana, and the Muladhara Cakkra, crying, "), _c('b', [_vm._v("BABALON!")])]), _vm._v(" "), _c('li', [_vm._v("Let him draw his thumb from right to left across his abdomen, at the level of the hips.")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All: "), _c('b', [_vm._v("Love is the law, love under will.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[A holograph note by Crowley states:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquoteb"
  }, [_c('ul', {
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_c('li', [_c('i', [_vm._v("Nuit and Hadit are Brain and Seed (Brahmarandra and Muladhara)")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Aiwaz is Silence and Speech (Ajna and Visuddhi)")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Ra Hoor Khuit is Force and Fire (Anahata)")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Therion is Manipura - or also Anahata?")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Babalon is Svadistthana, the Womb")])])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("Here Crowley relates the primary Thelemic gods to the chakras, or energy centres in the body, according to the Indian yogic system. In")]), _vm._v(" Liber ABA, Book 4 Part 2, "), _c('i', [_vm._v("Crowley describes them as being lotuses:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p8-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig6"
    }
  }), _c('b', [_vm._v("The NOX Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('i', [_vm._v("There is the lotus of three petals in the Sacrum, in which the Kundalini lies asleep. This lotus is the receptacle of reproductive force. There is also the six-petalled lotus opposite the navel—which receives the forces which nourish the body. There is also a lotus in the Solar plexus which receives the nervous forces. The six-petalled lotus in the heart corresponds to Tiphereth, and receives those vital forces which are connected with the blood. The sixteen-petalled lotus opposite the larynx receives the nourishment needed by the breath. The two-petalled lotus of the pineal gland receives the nourishment needed by thought, while above the junction of the cranial sutures is that sublime lotus, of a thousand and one petals, which receives the influence from on high; and in which, in the Adept, the awakened Kundalini takes her pleasure with the Lord of All.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteindent"
  }, [_c('i', [_vm._v("These chakras also relate to the fundamental Man of Earth Degrees in Ordo Templi Orientis.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Crowley's notes to Liber Reguli go on to say:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("...The Cross should include Hod and Netzach, Chokmah, and Binah")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The “Qabalistic Cross” must be that of the Grand Hierophant, but crowned by Nuit.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Here Crowley references how this also relates to the Hebrew Qabalah. We can clearly see his lifelong obsession with the creation of what might be called a “Grand Unified System” of magick, containing a synthesis of all the best bits from many different traditions. If you are a complete beginner and these references to Egyptology, Yoga, and Qabalah are over your head, you might wish to consult my previous book Abrahadabra, which provides a comprehensive introduction to these concepts.]")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("The Asseveration of the Spells.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Asseveration is the act of asserting something firmly and positively.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. Let the Magician clasp his hands upon his Wand, his fingers and thumbs interlaced, crying "), _c('b', [_vm._v("LAShTAL! THELEMA! FIAOF! AGAPE! AUMGN!")]), _vm._v(" (Thus shall be declared the Words of Power whereby the Energies of the Aeon of Horus work his will in the World.)")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[These words are pronounced: Lash-tal, Thel-e-ma, Ee-A-O, Ag-a-pay, A-oom. Note that the Fs in FIAOF and the GN in AUMGN are silent.]")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("All: "), _c('b', [_vm._v("The Word of the Law is Thelema!")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("The Proclamation of the Accomplishment.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. Let all strike the Battery: 3-5-3, crying "), _c('b', [_vm._v("ABRAHADABRA")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Have all members of the group clap together here, in a battery of three claps, five claps, three claps, then cry ABRAHADABRA together.]")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "c01-03"
    }
  }), _vm._v("The SECOND GESTURE")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("The Enchantment.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. Let the Magician, still facing Boleskine, advance to the circumference of his circle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2. Let him turn himself towards the left, and pace with the stealth and swiftness of a tiger the precincts of his circle, until he complete one revolution thereof.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("3. Let him give the Sign of Horus (or The Enterer) as he passeth, so to project the force that radiateth from Boleskine before him.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[This sign is made by leaning forward, advancing the left foot and throwing the arms out horizontally before you, as if to fire energy out of them.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("4. Let him pace his path until he comes to the North; there let him halt, and turn his face to the North.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[That is you go round one and a quarter times]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5. Let him trace with his wand the Averse Pentagram proper to invoke Air (Aquarius).")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[An averse pentagram is one with the single point down, two points up. The Averse Air pentagram is drawn by starting at the lower left point and going horizontally across to the right, then up left, down middle, up right, down left. i.e. go widdershins (anti-clockwise).]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("6. Let him bring the wand to the centre of the Pentagram and call upon "), _c('b', [_vm._v("NUIT!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[All of the people should assist the Magician by visualising the particular God or Goddess called in each quarter. If in doubt use the imagery shown in the Trump "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("cards of a Crowley Tarot pack. For Nuit, see Atu XVII, The Star; Atu XX, The Aeon; or Atu XXI, The Universe.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("7. Let all make the sign called Puella, standing with the feet together, head bowed, the left hand shielding the Muladhara Cakkra, and the right hand shielding the breast (attitude of the Venus de Medici).")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Puella, Puer, Mulier, Vir, Mater Triumphans are Latin for Girl, Boy, Woman, Man, Triumphant Mother. These signs are attributed to the five elements, and to the various stages that their energy manifests through.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("8. Let the Magician turn again to the left, and pursue his Path as before, projecting the force from Boleskine as he passeth; let him halt when he next cometh to the South and face outward.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[i.e. go round one and a half circles. See Crowley manuscript note below which explains why.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("9. Let him trace the Averse Pentagram that invoketh Fire (Leo).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Start bottom middle and go deosil (clockwise) i.e. go up left and then round until you've completed the entire pentagram.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10. Let him point his wand to the centre of the Pentagram, and cry, "), _c('b', [_vm._v("HADIT!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[See Atu XX, The Aeon - Hadit is the winged disk.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("11. Let all give the sign Puer, standing with feet together, and head erect. Let the right hand (the thumb extended at right angles to the fingers) be raised, the forearm vertical at a right angle with the upper arm, which is horizontally extended in the line joining the shoulders. Let the left hand, the thumb extended forwards and the fingers clenched, rest at the junction of the thighs (Attitude of the gods Mentu, Khem, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("12. Let the Magician proceed as before; then in the East, let him make the Averse Pentagram that invoketh Earth (Taurus).")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Another one and a quarter circles. The pentagram is drawn from bottom middle widdershins towards the upper right point and so on.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("13. Let him point his wand to the centre of the pentagram, and cry, "), _c('b', [_vm._v("THERION!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "fig7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p12-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p12-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig8"
    }
  }), _c('b', [_vm._v("Sign of the Enterer")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p12-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig9"
    }
  }), _c('b', [_vm._v("Sign of Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('i', [_vm._v("[See Atu XI, Lust - Therion is the Beast pictured.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("14. Let all give the sign called Vir, the feet being together. The hands, with clenched finger and thumbs thrust out forwards, are held to the temples; the head is then bowed and pushed out, as if to symbolize the butting of an horned beast (attitude of Pan, Bacchus, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15. Proceeding as before, let the Magician make in the West the Averse Pentagram whereby Water is invoked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[Another one and a half circles. A Crowley manuscript note says: “11 half-circles, or 5 1/2 circles to unite 5 & 6. Puer makes him Vir; Vir makes Puella - Mulier.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteindent"
  }, [_c('i', [_vm._v("The Averse pentagram of Water: start at the lower right and go horizontally across to the lower left and thus round deosil. Note that the pentagrams change direction each time - first widdershins, then deosil, then widdershins again, then deosil.]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("16. Pointing the wand to the centre of the Pentagram, let him call upon "), _c('b', [_vm._v("BABALON!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[See Atu XI again - Babalon is the Goddess riding on the Beast.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("17. Let all give the sign Mulier. The feet are widely separated, and the arms raised so as to suggest a crescent. The head is thrown back (attitude of Baphomet, Isis in Welcome, the Microcosm of Vitruvius). (See "), _c('i', [_vm._v("Book 4,")]), _vm._v(" Part II).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("18. Let the Magician break into the dance, tracing a centripetal spiral widdershins, enriched by revolutions upon his axis as he passeth each quarter, until he come to the centre of the circle. There let him halt, facing Boleskine.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[You go round the circle one complete revolution here.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("19. Let him raise the wand, trace the Mark of the Beast, and cry "), _c('b', [_vm._v("AIWAZ!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("[Crowley's notes say: Trace the mark where Sol is Hadit, Luna Nuit, and the Testes 666 and 156. The Mark of the Beast is composed of three sections: the top circle with point in the middle represents the sun, Sol, and is assigned to the Thelemic god Hadit; the crescent just below is the moon, Luna, and assigned to the goddess Nuit; and the two semi-circles at the bottom (Testes) are assigned to 666 (To Mega Therion) and 156 (Babalon).")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteindent"
  }, [_c('i', [_vm._v("Aiwaz should be visualised as “a tall dark man in his thirties, well-knit, active and strong, with the face of a savage king, and eyes veiled lest their gaze destroy what "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("they saw.” A Crowley typescript note refers to the wand here as a “Prometheus-tube”, the inference being that the Magician is drawing down divine energy to the Earth in this section.]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("20. Let him trace the invoking Hexagram of The Beast.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[This is the Unicursal Hexagram, drawn from the top middle point deosil towards the bottom right, top left, bottom middle, top right, bottom left, top middle.]")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("21. Let him lower the wand, striking the Earth therewith.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("22. Let all give the sign of Mater Triumphans (The feet are together; the left arm is curved as if it supported a child; the thumb and index finger of the right hand pinch the nipple of the left breast, as if offering it to that child). Let all utter the word "), _c('b', [_vm._v("THELEMA")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("23. Let the Magician perform the spiral dance, moving deosil and whirling widdershins. Each time on passing the West he should extend the wand to the Quarter in question, and bow:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[Note that he extends the wand to the quarter, not bows to the quarter. Each time he bows to the West.]")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "lower-alpha"
    }
  }, [_c('li', [_vm._v("“"), _c('b', [_vm._v("Before me the powers of LA!")]), _vm._v("” (to West.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("Behind me the powers of AL!")]), _vm._v("” (to East.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("On my right hand the powers of LA!")]), _vm._v("” (to North.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("On my left hand the powers of AL!")]), _vm._v("” (to South.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("Above me the powers of ShT!")]), _vm._v("” (leaping in the air.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("Beneath me the powers of ShT!")]), _vm._v("” (striking the ground.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("Within me the Powers!")]), _vm._v("” (in the attitude of Phthah erect, the feet together, the hands clasped upon the vertical wand.)")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("About me flames my Father's face, the Star of Force and Fire.")]), _vm._v("”")]), _vm._v(" "), _c('li', [_vm._v("“"), _c('b', [_vm._v("And in the Column stands His six-rayed Splendour!")]), _vm._v("”\n"), _c('p', {
    staticClass: "text"
  }, [_vm._v("(This dance may be omitted, and the whole utterance chanted in the attitude of Phthah.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("[The attitude of Phthah is standing upright, the feet together, with the wand clenched with both hands upright against the chest]")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle1"
  }, [_c('a', {
    attrs: {
      "id": "c01-04"
    }
  }), _vm._v("The FINAL GESTURE")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("This is identical with the First Gesture.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f6d4f6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter01.vue
// module id = 81
// module chunks = 0